import { createFileRoute } from '@tanstack/react-router';
import ClientManagement from '../../components/manager/ClientManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/clients')({
  component: ClientManagementRoute,
});

function ClientManagementRoute() {
  return (
    <ManagerPortal>
      <ClientManagement />
    </ManagerPortal>
  );
}
